<template>
  <v-select
    v-model="item"
    dir="rtl"
    :multiple="multiple"
    :clearable="clearable"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    :selectable="() => Array.isArray(item) ? item.length < limit : true"
    @open="onOpen"
    @option:selected="$emit('selected')"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'SegmentSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  computed: {
    ...mapState('zirehState', { items: state => state.segmentSelect }),
    ...mapState('zirehState', { flag: state => state.segmentSelectFlag }),
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setSegmentSelectFlag', true)
        this.loading = true
        this.$http.post(
          this.$api.segmentBasic.getall, {},
        )
          .then(res => {
            this.$store.commit('zirehState/setSegmentSelect', res.data)
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
